import type { ListingTask } from "../next/cards/ListingActions";
export type ContentPhoto = { id: number; position: number; url: string; download_url: string; chosen: boolean; post_position?: number | null; is_front: boolean };
export type ContentJob = {
  id: string; product_id: string | null; sku: string | null; title: string;
  mode: "post" | "image_only"; revision: string; status: "todo" | "working" | "ready" | "published";
  job_status: string; caption: string; scene: string; price: number | null;
  cover_url: string | null; cover_download_url: string | null; previous_cover: boolean;
  photos: ContentPhoto[]; task: { id: string; status: string; action: string; progress: string | number; error: string | null } | null;
  marketplace: { title: string; description: string } | null;
  usage?: { request_count: number; known_cost_usd: number | null; actual_cost_usd: number | null; currency: "USD" };
  listings: Partial<Record<"telegram" | "avito" | "oskelly", { status: string; url: string | null }>>;
  can_edit: boolean; can_publish: boolean; can_upload_photos: boolean; blocker: string | null; publish_blocker?: string | null; can_generate_marketplace?: boolean;
  caption_blocker?: string | null;
  listing_tasks?: ListingTask[];
  can_send_photos?: boolean; can_send_text?: boolean; can_retry_comments?: boolean;
};
export const contentStatuses = { todo: "Нужно подготовить", working: "В работе", ready: "Готово", published: "Опубликовано" };
export const taskRunning = (job?: ContentJob) => !!job?.task && ["queued", "running"].includes(job.task.status);
export function usageCost(usage: NonNullable<ContentJob["usage"]>) {
  const known = usage.actual_cost_usd ?? usage.known_cost_usd;
  if (known == null || (known === 0 && usage.actual_cost_usd == null)) return "Стоимость уточняется";
  if (known > 0 && known < 0.000001) return "менее 0,000001 $";
  return new Intl.NumberFormat("ru-RU", { style: "currency", currency: "USD", maximumFractionDigits: 6 }).format(known);
}
export const selectionError = (ids: number[], front: number | null, photos: ContentPhoto[]) => {
  if (ids.length !== 2 || new Set(ids).size !== 2) return "Выберите ровно 2 разных фото для поста.";
  if (ids.some((id) => !photos.some((photo) => photo.id === id))) return "Одно из выбранных фото больше недоступно.";
  if (front == null || !photos.some((photo) => photo.id === front)) return "Выберите фронтальное фото сумки для образа.";
  return null;
};
